import React from 'react'
import PostTitleParagraph from 'components/post/PostTitleParagraph'
import PostTextArea from 'components/post/PostTextArea'
import PostImage from 'components/post/PostImage'
import PostVideo from 'components/post/PostVideo'
import PostList from 'components/post/PostList'
import PostStats from 'components/post/PostStats'

export default function Postbuilder({ content, isSmallerTitles = false }) {
  return (
    <>
      {content.map((block, i) => {
        if (block) {
          if (
            [
              'Page_Postbuilder_Postbuilder_Titleparagraph',
              'Post_Postbuilder_Postbuilder_Titleparagraph',
            ].includes(block.fieldGroupName)
          ) {
            return (
              <PostTitleParagraph
                key={i}
                content={block}
                isSmallerTitles={isSmallerTitles}
              />
            )
          }
          if (
            [
              'Page_Postbuilder_Postbuilder_Textarea',
              'Post_Postbuilder_Postbuilder_Textarea',
            ].includes(block.fieldGroupName)
          ) {
            return <PostTextArea key={i} content={block} />
          }
          if (
            [
              'Page_Postbuilder_Postbuilder_Image',
              'Post_Postbuilder_Postbuilder_Image',
            ].includes(block.fieldGroupName)
          ) {
            return <PostImage key={i} content={block} />
          }
          if (
            [
              'Page_Postbuilder_Postbuilder_Video',
              'Post_Postbuilder_Postbuilder_Video',
            ].includes(block.fieldGroupName)
          ) {
            return <PostVideo key={i} content={block} />
          }
          if (
            [
              'Page_Postbuilder_Postbuilder_List',
              'Post_Postbuilder_Postbuilder_List',
            ].includes(block.fieldGroupName)
          ) {
            return <PostList key={i} content={block} />
          }
          if (
            [
              'Post_Postbuilder_Postbuilder_Stats',
              'Post_Postbuilder_Postbuilder_Stats',
            ].includes(block.fieldGroupName)
          ) {
            return <PostStats key={i} content={block} />
          }
        }
      })}
    </>
  )
}
